import type {
	AuthenticatorTransportFuture,
	PublicKeyCredentialDescriptorJSON,
	PublicKeyCredentialRequestOptionsJSON
} from '@simplewebauthn/browser'
import { startAuthentication } from '@simplewebauthn/browser'

const WEBAUTHN_TRANSPORTS = [
	'ble',
	'cable',
	'hybrid',
	'internal',
	'nfc',
	'smart-card',
	'usb'
] as const

interface PasskeyCredentialDescriptorJson {
	id: string
	type: 'public-key'
	transports?: string[]
}

interface PasskeyRequestOptionsJson
	extends Omit<
		PublicKeyCredentialRequestOptionsJSON,
		'allowCredentials' | 'extensions'
	> {
	allowCredentials?: PasskeyCredentialDescriptorJson[]
}

function toCredentialDescriptor(
	descriptor: PasskeyCredentialDescriptorJson
): PublicKeyCredentialDescriptorJSON {
	return {
		id: descriptor.id,
		type: descriptor.type,
		transports: descriptor.transports?.filter(
			(transport): transport is AuthenticatorTransportFuture =>
				WEBAUTHN_TRANSPORTS.some((value) => value === transport)
		)
	}
}

export async function getPasskeyAssertion(options: PasskeyRequestOptionsJson) {
	const credential = await startAuthentication({
		optionsJSON: {
			challenge: options.challenge,
			timeout: options.timeout,
			rpId: options.rpId,
			allowCredentials: options.allowCredentials?.map(
				toCredentialDescriptor
			),
			userVerification: options.userVerification,
			hints: options.hints
		}
	})

	return {
		...credential,
		clientExtensionResults: { ...credential.clientExtensionResults }
	}
}
